import type { ReactNode } from 'react';

export const symbol_repartition: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m195-664 52 52q9 8.8 9 20.9 0 12.1-9.05 21.1-9.06 9-21.5 9-12.45 0-21.45-9L101-673q-9-9-9-21t9-21l104-104q9-9 21.16-9t21 8.61Q256-810 256-797.53q0 12.46-9 21.53l-52 52h483q66.83 0 114.41 47.62Q840-628.75 840-561.88q0 66.88-47.69 114.38T677.65-400H150q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h528q42.08 0 72.04-29.95 29.96-29.94 29.96-72Q780-604 750.04-634T678-664H195Zm-75 524v-120q0-24.75 17.63-42.38Q155.25-320 180-320h600q24.75 0 42.38 17.62Q840-284.75 840-260v120q0 24.75-17.62 42.37Q804.75-80 780-80H180q-24.75 0-42.37-17.63Q120-115.25 120-140Zm60 0h163v-120H180v120Zm223 0h153v-120H403v120Zm214 0h163v-120H617v120Z"
		/>
	</svg>
);
